module.exports = __webpack_public_path__ + "img/Gallery_2_01.5e3a6d6a.jpeg";